import { PropertyDetails } from '@features/ForestOwner/Search/Property/PropertyDetails'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/forestowner/$forestownerId/property/$propertyId/')({
  component: RouteComponent,
  staticData: {
    breadcrumb: 'Eiendom',
  },
})

function RouteComponent() {
  return <PropertyDetails />
}
